export default __webpack_public_path__ + "static/media/proj15.cfbf52cd.png";